module.exports = __webpack_public_path__ + "img/AZ.d97af444.png";